export interface MenuItem {
  code: string;
  label: string;
  path: string;
  icon: string;
  access: number[];
}
export const MENUS: MenuItem[] = [
  {
    code: 'dashboard',
    label: 'Dashboard',
    path: '/dashboard',
    icon: 'Dashboard',
    access: [1, 5, 10]
  },
  {
    code: 'clusters',
    label: 'Clusters',
    path: '/clusters',
    icon: 'Cloud',
    access: [1, 5, 10]
  },
  {
    code: 'streams',
    label: 'Streams',
    path: '/streams',
    icon: 'Stream',
    access: [1, 5, 10]
  },
  {
    code: 'destinations',
    label: 'Destinations',
    path: '/destinations',
    icon: 'Destination',
    access: [1, 5, 10]
  },
  {
    code: 'multiview',
    label: 'Multiview',
    path: '/multiview',
    icon: 'Grid',
    access: [1, 5, 10]
  },
  {
    code: 'transcoding-scenarios',
    label: 'Transcoding',
    path: '/transcoding-scenarios',
    icon: 'Transcoding',
    access: [1, 5, 10]
  },
  {
    code: 'dvr',
    label: 'DVR',
    path: '/dvr',
    icon: 'DVR',
    access: [1, 5, 10]
  },
  {
    code: 'clippost',
    label: 'Clip & Post',
    path: '/clips',
    icon: 'Clippost',
    access: [1, 5, 10]
  },
  {
    code: 'production',
    label: 'Production',
    path: '/production',
    icon: 'Production',
    access: [1, 5, 10]
  }
];
